const createArrayParamWithoutBrackets = (queryName: string, values: (string | number)[]) => {
    if (values?.length > 0) {
        return `?${queryName}=${values.join(`&${queryName}=`)}`;
    }

    return '';
};

export default {
    createArrayParamWithoutBrackets,
};
